import ChecklistFilter, {
  ChecklistFilterOption,
} from '@/components/common/Grid/ChecklistFilter/ChecklistFilter';
import { TranslatableColDef } from '@/components/common/Grid/TranslatableColDef';

const actionColumnField = 'action';

const activeChangeRequestFilterOptions: ChecklistFilterOption[] = [
  { searchKey: 'True', translationKey: 'product.yes' },
  { searchKey: 'False', translationKey: 'product.no' },
];

const activeChangeRequestColumn: TranslatableColDef = {
  field: 'activeChangeRequestId',
  tooltipField: 'activeChangeRequestId',
  headerName: 'Pending Changes',
  initialHide: true,
  sortable: true,
  resizable: true,
  filter: ChecklistFilter,
  suppressHeaderMenuButton: false,
  filterParams: {
    options: activeChangeRequestFilterOptions,
  },
  cellRenderer: (props: any) => (props.value ? 'Yes' : null),
  flex: 1.4,
  minWidth: 150,
};

export function withActiveChangeRequestColumn(
  columns: TranslatableColDef[],
  hasInternalAccess: boolean
) {
  if (
    !hasInternalAccess ||
    columns.some((column) => column.field === activeChangeRequestColumn.field)
  ) {
    return columns;
  }

  const actionColumnIndex = columns.findIndex(
    (column) => column.field === actionColumnField
  );
  if (actionColumnIndex < 0) {
    return [...columns, activeChangeRequestColumn];
  }

  return [
    ...columns.slice(0, actionColumnIndex),
    activeChangeRequestColumn,
    ...columns.slice(actionColumnIndex),
  ];
}
